import * as React from "react";
const SvgSort = (props) => /* @__PURE__ */ React.createElement("svg", { width: 8, height: 5, viewBox: "0 0 8 5", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props }, /* @__PURE__ */ React.createElement("path", { d: "M3.76273 4.72998L0.504163 0.432479L7.02129 0.432478L3.76273 4.72998Z", fill: "black", fillOpacity: 0.3 }));
export default SvgSort;
